import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/pinwheel.webp'


const _withScopeId = n => (_pushScopeId("data-v-c2444fc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["loading"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "pinwheel",
  src: _imports_0
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    loading: _ctx.loading,
    class: "preloader"
  }, [
    _hoisted_2,
    _createElementVNode("p", null, _toDisplayString(_ctx.text), 1)
  ], 8, _hoisted_1))
}